import tmLogo from "@/assets/transportmate-logo-blue-transparent.png";

/**
 * Branded splash / launch overlay.
 * Premium native launch overlay with a concise branded loading state.
 */
export const Splash = ({ fadingOut = false }: { fadingOut?: boolean }) => {
  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center overflow-hidden bg-card text-foreground"
      style={{
        opacity: fadingOut ? 0 : 1,
        transition: "opacity 200ms ease-out",
        pointerEvents: fadingOut ? "none" : "auto",
      }}
      role="status"
      aria-live="polite"
      aria-label="TransportMate is loading"
    >
      {/* Logo */}
      <img
        src={tmLogo}
        alt="TransportMate"
        className="h-auto w-[min(72vw,280px)] object-contain splash-logo-in"
      />

      {/* Tagline */}
      <p
        className="mt-5 max-w-[280px] px-4 text-center font-body text-sm font-medium text-muted-foreground splash-copy-in"
      >
        Connecting Drivers, Customers &amp; Vehicles
      </p>
      <div className="mt-8 flex items-center gap-2" aria-hidden="true">
        <span className="splash-loading-dot" />
        <span className="splash-loading-dot [animation-delay:120ms]" />
        <span className="splash-loading-dot [animation-delay:240ms]" />
      </div>

      <style>{`
        @keyframes splash-logo-in {
          0%   { opacity: 0; transform: scale(0.96); }
          100% { opacity: 1; transform: scale(1); }
        }
        .splash-logo-in {
          opacity: 0;
          animation: splash-logo-in 360ms ease-out forwards;
        }
        @keyframes splash-copy-in {
          from { opacity: 0; transform: translateY(4px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .splash-copy-in {
          opacity: 0;
          animation: splash-copy-in 300ms ease-out 160ms forwards;
        }
        @keyframes splash-dot {
          0%, 100% { opacity: 0.25; transform: scale(0.8); }
          50% { opacity: 1; transform: scale(1); }
        }
        .splash-loading-dot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: hsl(var(--primary));
          animation: splash-dot 720ms ease-in-out infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .splash-logo-in, .splash-copy-in, .splash-loading-dot {
            animation: none;
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default Splash;
